import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { PdfViewerModule as ng2PdfViewerModule } from 'ng2-pdf-viewer';
import { ClientService } from './components/client/client.service';
import { CreateTicketDialogModule } from './components/create-ticket-dialog/create-ticket-dialog.module';
import { PdfViewerDesktopService } from './components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { KieneCoreComponent } from './kiene-core.component';
import { ReplaceNullWithTextPipe } from './utils/pipes/replace-null-with-text.pipe';

@NgModule({
    declarations: [KieneCoreComponent, ReplaceNullWithTextPipe],
    imports: [
        MatDialogModule,
        MatButtonModule,
        ng2PdfViewerModule,
        CommonModule,
        MatIconModule,
        MatCardModule,
        MatDividerModule,
        MatSliderModule,
        MatCheckboxModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        CreateTicketDialogModule,
    ],

    providers: [ClientService, PdfViewerDesktopService],

    exports: [KieneCoreComponent, ReplaceNullWithTextPipe],
})
export class KieneCoreModule {}
